import typeCheck from 'common/util/typeCheck';
import analytics from 'client/analytics';
import { ANALYTICS_EVENT_GUARANTOR_SIGNUP } from 'client/analytics/eventList';
import { USER_ROLE_ANONYMOUS } from 'common/userRoles';
import { onLogicSuccess } from 'client/actions/Auth/login';

import {
  SR_API_ACTION_GUARANTOR_SIGNUP,
} from 'api/actionTypes';

export default async function guarantorSignup({ state, apiClient }, params) {
  typeCheck('params::Object', params);

  const wasAlreadyLoggedIn = !state.get(['currentUser', 'roles']).includes(USER_ROLE_ANONYMOUS);

  const {
    name,
    phone,
    password,
    guarantorForUserId,
    guarantorForHouseholdId,
  } = params;

  const analyticsSessionId = state.get(['analytics', 'analyticsSessionId']);
  const experimentActiveVariants = state.get(['analytics', 'experiments', 'activeVariants']);

  await apiClient.postWithState({
    action: SR_API_ACTION_GUARANTOR_SIGNUP,
    state: state,
    payload: {
      name,
      phone,
      password,
      guarantorForUserId,
      guarantorForHouseholdId,
      analyticsSessionId,
      experimentActiveVariants,
    },
    async onSuccess({ user }) {
      await onLogicSuccess({
        state,
        apiClient,
        user,
      });

      analytics.track(ANALYTICS_EVENT_GUARANTOR_SIGNUP, {
        phone,
        guarantorForUserId,
        guarantorForHouseholdId,
        wasAlreadyLoggedIn,
      });
    },
  });
}
